export default {
    methods: {
        suffixIf(condition, string, suffix) {
            return eval(condition) ? `${string}${suffix}` : string
        }
    }
}
